import React,{useState,useEffect} from 'react';
import axios from 'axios';
import JobCard from './JobCard';
import Pagination from './Pagination';
import { getApiUrl } from '../config/api';
import { Stack } from '../Components/ui/layout';


const JobList = () => {
  const [jobsData,setJobsData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 5;

  useEffect(() => {
    const fetchJobs = async () => {
    try {
      const response = await axios.get(getApiUrl('/user/jobs'));
      // Debug log removed — was leaking jobs list to console.
      setJobsData(response.data);
    } catch (error) {
      console.error("Failed to fetch job postings:", error);
    }
  }
  fetchJobs();
},[]);

 // Calculate the indexes for slicing the jobs data
 const indexOfLastJob = currentPage * jobsPerPage;
 const indexOfFirstJob = indexOfLastJob - jobsPerPage;
 const currentJobs = jobsData.slice(indexOfFirstJob, indexOfLastJob);

 const handlePageChange = (newPage) => {
   setCurrentPage(newPage);
 };
  return (
    <Stack spacing="md" className="flex-1 w-full">
      {currentJobs.map((job, index) => (
        <JobCard key={index} job={job} />
      ))}
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(jobsData.length / jobsPerPage)}
        onPageChange={handlePageChange}
      />
    </Stack>
  );
};

export default JobList;